import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AppShell from "@/components/layout/AppShell";
import Home from "@/pages/Home";
import EngineView from "@/pages/EngineView";
import EnginePlaceholder from "@/pages/EnginePlaceholder";
import Wallet from "@/pages/Wallet";
import Turn from "@/pages/Turn";
import Closures from "@/pages/Closures";
import Executive from "@/pages/Executive";
import Forecast from "@/pages/Forecast";
import Ingestion from "@/pages/Ingestion";
import Settings from "@/pages/Settings";
import Welcome from "@/pages/Welcome";
import FounderHandoff from "@/pages/FounderHandoff";
import GHLEntry from "@/pages/GHLEntry";
import DeliveryChecklist from "@/pages/DeliveryChecklist";
import AdminBetaResetPreview from "@/pages/AdminBetaResetPreview";
import { ENGINES } from "@/config/engines";

function App() {
  return (
    <div className="App selection-amber">
      <BrowserRouter>
        <Routes>
          <Route path="/bienvenida" element={<Welcome />} />
          <Route path="/socio-fundador" element={<FounderHandoff />} />
          <Route path="/entry" element={<GHLEntry />} />
          {/* Herramienta administrativa temporal (Beta Reset preview) --
              deliberadamente fuera de AppShell y sin ningún enlace en la
              navegación del producto. Solo se llega escribiendo esta URL
              directamente. Ver AdminBetaResetPreview.jsx. */}
          <Route path="/admin/beta-reset-preview" element={<AdminBetaResetPreview />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/turn" element={<Turn />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/closures" element={<Closures />} />
            <Route path="/executive" element={<Executive />} />
            <Route path="/forecast" element={<Forecast />} />
            <Route path="/ingestion" element={<Ingestion />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/entrega" element={<DeliveryChecklist />} />

            {/* Engines: rendered generically. Live engines use EngineView,
                coming-soon engines use EnginePlaceholder. */}
            {ENGINES.map((e) => (
              <Route
                key={e.id}
                path={e.path}
                element={
                  e.status === "live"
                    ? <EngineView engineId={e.id} />
                    : <EnginePlaceholder engineId={e.id} />
                }
              />
            ))}

            {/* Legacy redirects */}
            <Route path="/recovery" element={<Navigate to="/engines/recovery" replace />} />
            <Route path="/dashboard" element={<Navigate to="/executive" replace />} />
            <Route path="/upload" element={<Navigate to="/ingestion" replace />} />
            <Route path="/cartera" element={<Navigate to="/wallet" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#131b30",
            border: "1px solid #1b2846",
            color: "#f4f4f5",
            borderRadius: "2px",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
